import React from "react";
import { Demographics } from "../survey-types";

interface DemographicFormProps {
  demographicTarget: Demographics | undefined;
  onDemographicTargetChange: (key: keyof Demographics, value: any) => void;
}

const DemographicForm: React.FC<DemographicFormProps> = ({
  demographicTarget,
  onDemographicTargetChange,
}) => {
  return (
    <div>
      <div className="mb-4">
        {/* <h2 className="text-2xl font-bold mb-4">Target audience</h2> */}
        <label className="block" htmlFor="target-audience">
          Target Audience
        </label>
        <textarea
          id="target-audience"
          className="bg-slate-600 text-white text-sm mt-2 w-full sm:w-[800px] h-32"
          value={demographicTarget?.targetAudience || ""}
          placeholder="E.g, Women aged 30-40, living in medium and large cities in the US, belonging to the middle and upper class."
          onChange={(e) =>
            onDemographicTargetChange("targetAudience", e.target.value)
          }
        />
      </div>
    </div>
  );
};

export default DemographicForm;
